// extracted by mini-css-extract-plugin
var _1 = "DocFlowMapping-moduleDocFlowMapping__m3Ece";
var _2 = "DocFlowMapping-moduledoneIcon__nLDYd FilePreviewOverlay-moduleselectIcon__WwvhF FilePreviewOverlay-moduleicon__E45rA";
var _3 = "DocFlowMapping-modulenavButton__x0Ooc NavArrowButton-moduleNavArrowButton__PbEBW Button-modulebutton__AisLs Flat-moduleflat__s3eC8";
var _4 = "DocFlowMapping-modulenavButtonLeft__Dfsm7";
var _5 = "DocFlowMapping-modulenavButtonRight__K9Ed4";
var _6 = "DocFlowMapping-modulepdfPreview__AEujT PdfPreview-modulePdfPreview__r1jH9";
var _7 = "DocFlowMapping-modulepdfViewer__wXEvJ PdfViewer-modulePdfViewer__x8M2s";
var _8 = "DocFlowMapping-modulepreviewContent__GGWLJ";
var _9 = "DocFlowMapping-moduleskeleton__E4XQW Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "DocFlowMapping", _2 as "doneIcon", _3 as "navButton", _4 as "navButtonLeft", _5 as "navButtonRight", _6 as "pdfPreview", _7 as "pdfViewer", _8 as "previewContent", _9 as "skeleton" }
